import classNames from 'classnames';
import { FC } from 'react';

import { IcBack2Icon, IcNextIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import styles from './CarouselControls.styles.m.css';

interface ICarouselControlsProps {
  showPrevButton: boolean;
  showNextButton: boolean;
  withShadow?: boolean;
  onPrev(): void;
  onNext(): void;
}

export const CarouselControls: FC<ICarouselControlsProps> = ({
  showPrevButton,
  showNextButton,
  withShadow,
  onPrev,
  onNext,
}) => {
  return (
    <>
      {showPrevButton && (
        <div
          className={classNames(
            styles.buttonWrapper,
            styles.prev,
            withShadow ? styles.withShadow : undefined
          )}
        >
          <FAB
            className={classNames(styles.button, styles.prev)}
            Icon={IcBack2Icon}
            theme="7"
            size="30"
            onClick={onPrev}
          />
        </div>
      )}
      {showNextButton && (
        <div
          className={classNames(
            styles.buttonWrapper,
            styles.next,
            withShadow ? styles.withShadow : undefined
          )}
        >
          <FAB
            className={classNames(styles.button, styles.next)}
            Icon={IcNextIcon}
            theme="7"
            size="30"
            onClick={onNext}
          />
        </div>
      )}
    </>
  );
};
